import { render, staticRenderFns } from "./DataReporting.vue?vue&type=template&id=63a60e18&scoped=true&"
import script from "./DataReporting.vue?vue&type=script&lang=js&"
export * from "./DataReporting.vue?vue&type=script&lang=js&"
import style0 from "./DataReporting.vue?vue&type=style&index=0&id=63a60e18&prod&lang=scss&scoped=true&"
import style1 from "./DataReporting.vue?vue&type=style&index=1&id=63a60e18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a60e18",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QField from 'quasar/src/components/field/QField.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QItemLabel,QIcon,QMenu,QCard,QBtn,QCheckbox,QScrollArea,QDialog,QField});qInstall(component, 'directives', {Ripple});
